import type { Moment } from 'moment';
import { roundMoney } from './libs';

// Spending pace for the month so far: the daily average and the month it
// points to, compared with last month's total.

export type SpendingPace = {
  dailyAverage: number;
  /** Days the average is taken over: the 1st through today. */
  days: number;
  /** The month's projected total at the daily average. */
  projected: number;
  /** Projected against last month as a fraction (-0.9 = 90% less); null when last month had nothing. */
  changeVsPrevious: number | null;
};

export function getSpendingPace({
  totalExpenses,
  previousTotal,
  monthStart,
  now,
}: {
  totalExpenses: number;
  previousTotal: number;
  monthStart: Moment;
  now: Moment;
}): SpendingPace | null {
  const total = Number(totalExpenses || 0);
  if (total <= 0) return null;
  // Whole days since the 1st, plus today: the total includes today's spending.
  const days = now.diff(monthStart, 'days') + 1;
  const dailyAverage = total / days;
  // Round once at the end, not the daily rate before multiplying.
  const projected = roundMoney(dailyAverage * now.daysInMonth());
  const previous = Number(previousTotal || 0);
  const changeVsPrevious =
    previous > 0 ? (projected - previous) / previous : null;
  return { dailyAverage, days, projected, changeVsPrevious };
}
